// Whether the Fan AI launcher bubble is on screen, shared with the other
// bottom-right corner UI (the ScoreLM corner badge, #489) so the two stack
// instead of overlapping. Set by FanAiBubble; read with useFanAiLauncherVisible.
// A tiny module store: no extra request, no provider.

import { useSyncExternalStore } from 'react'

let visible = false
const listeners = new Set<() => void>()

export function setFanAiLauncherVisible(next: boolean): void {
  if (visible === next) return
  visible = next
  listeners.forEach((l) => l())
}

function subscribe(l: () => void): () => void {
  listeners.add(l)
  return () => void listeners.delete(l)
}

export function useFanAiLauncherVisible(): boolean {
  return useSyncExternalStore(subscribe, () => visible, () => false)
}
